import React from 'react';
import { Navigate } from 'react-router-dom';

// Used this site as reference: https://medium.com/@tomlarge/private-routes-with-react-router-dom-28e9f40c7146
export const PrivateRoute = ({ children, condition }) => {
  return condition ? children : <Navigate to='/' replace />;
};
